import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, UserIcon, UsersIcon } from 'lucide-react';
import { SectionTag } from './SectionTag';
import { DELEGATION_TASKS } from './salesData';
export function DelegationSection() {
  return <section id="equipo" className="bg-sand py-12 sm:py-16" data-id="element-104" data-mp="ng2wn0z0lvm1">
      <div className="mx-auto max-w-4xl px-5" data-id="element-105" data-mp="sgqxsfgyjstz">
        <div className="text-center" data-id="element-106" data-mp="see5p9hhk237">
          <SectionTag data-id="element-107" data-mp="xg3j2vs6krug">Con o sin equipo</SectionTag>
          <h2 className="mt-4 font-display text-[1.4rem] font-bold uppercase leading-tight text-charcoal sm:text-[2rem]" data-id="element-108" data-mp="xfbonoabl05r">
            Lo podés aplicar solo.
            <span className="mt-1 block text-gold-deep" data-id="element-109" data-mp="167lxb15kgxkw">Y también podés delegarlo.</span>
          </h2>
          <p className="mx-auto mt-4 max-w-2xl font-sans text-[0.9rem] leading-relaxed text-charcoal/70 sm:text-base" data-id="element-110" data-mp="1b78cvh8vapwv">
            El sistema está pensado para que lo implemente el odontólogo solo, sin depender de nadie.
            Pero si tenés secretaria o asistente, buena parte del circuito puede quedar en sus manos
            con guiones y planillas ya definidos.
          </p>
        </div>

        <div className="mt-8 grid gap-3 sm:grid-cols-2" data-id="element-111" data-mp="225pmdt5if6qd">
          <div className="rounded-2xl border border-stone bg-ivory p-5" data-id="element-112" data-mp="228bv3w44zsa6">
            <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-gold-soft" data-id="element-113" data-mp="1x762rzee2716">
              <UserIcon className="h-5 w-5 text-gold-deep" aria-hidden data-id="element-114" data-mp="1t73z5kp3f3j9" />
            </span>
            <h3 className="mt-3.5 font-display text-base font-bold uppercase leading-snug text-charcoal" data-id="element-115" data-mp="2pv1xiykedovb">
              Si trabajás solo
            </h3>
            <p className="mt-1.5 font-sans text-[0.84rem] leading-relaxed text-charcoal/70" data-id="element-116" data-mp="2g5i9lehtv4tl">
              Aplicás el sistema en bloques cortos: unos minutos por día para responder consultas,
              confirmar turnos y hacer seguimiento de presupuestos. Nada requiere personal extra.
            </p>
          </div>

          <div className="rounded-2xl border border-stone bg-ivory p-5" data-id="element-117" data-mp="33u9xhtodx10k">
            <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-gold-soft" data-id="element-118" data-mp="11y2ihu54itui">
              <UsersIcon className="h-5 w-5 text-gold-deep" aria-hidden data-id="element-119" data-mp="16wm3nsbw81lt" />
            </span>
            <h3 className="mt-3.5 font-display text-base font-bold uppercase leading-snug text-charcoal" data-id="element-120" data-mp="s895copc26o5">
              Si tenés secretaria o asistente
            </h3>
            <p className="mt-1.5 font-sans text-[0.84rem] leading-relaxed text-charcoal/70" data-id="element-121" data-mp="x4zk98peiw7z">
              Le entregás guiones, checklists y planillas listas. Vos te quedás con el sillón y el
              criterio clínico; el circuito comercial funciona sin que lo tengas que sostener.
            </p>
          </div>
        </div>

        <div className="mt-4 rounded-2xl border border-stone bg-ivory p-5 sm:p-6" data-id="element-122" data-mp="e7ycxh8dkk0v">
          <h3 className="text-center font-display text-base font-bold uppercase text-charcoal sm:text-lg" data-id="element-123" data-mp="ea1acmbuxffm">
            Tareas que se pueden delegar
          </h3>
          <ul className="mt-4 grid gap-x-6 gap-y-1.5 sm:grid-cols-2" data-id="element-124" data-mp="28lpk8a38ert5">
            {DELEGATION_TASKS.map((task, i) => <motion.li key={task} initial={{
            opacity: 0,
            x: -8
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true,
            margin: '-40px'
          }} transition={{
            duration: 0.3,
            delay: i * 0.04
          }} className="flex items-start gap-2" data-id="element-125" data-mp="3t276vg7tve0k" data-mpi={i}>
                <CheckIcon className="mt-[3px] h-3.5 w-3.5 shrink-0 text-gold" aria-hidden data-id="element-126" data-mp="fou8lrhlb7mt" />
                <span className="font-sans text-[0.82rem] leading-snug text-charcoal/75" data-id="element-127" data-mp="bobfzv7vhxjk">
                  {task}
                </span>
              </motion.li>)}
          </ul>
        </div>
      </div>
    </section>;
}